import FileFilters from './FileFilters.view';

export default FileFilters;



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/Files/FileFilters/index.js